import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';

import TicketNumberSummary from './TicketNumberSummary';
import { queryTicketNumberGQL } from '../graphql/index';
import { getTicketNumberId, getTicketNumberObject } from '../selectors';


const mapStateToProps = (state) => {
  return {
    ticketNumberId: getTicketNumberId(state),
    ticketNumberObject: getTicketNumberObject(state),
  };
};

const withNoTicketNumberObject = branch(
  (props) => {
    const { ticketNumberObject } = props;
    return Object.keys(ticketNumberObject).length === 0;
  },
  renderNothing,
);

const withRedux = connect(mapStateToProps, {});

const enhance = compose(
  withRedux,
  withNoTicketNumberObject,
  queryTicketNumberGQL,
);

export default enhance(TicketNumberSummary);
